// extracted by mini-css-extract-plugin
export default {"profileSection":"profile_profileSection__OORgy"};